export { MedicalCard } from './MedicalCard.main';
